function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 9C5 8.59375 4.65625 8.25 4.25 8.25H0.75C0.3125 8.25 0 8.59375 0 9C0 9.4375 0.3125 9.75 0.75 9.75H4.25C4.65625 9.75 5 9.4375 5 9ZM17.25 8.25H13.75C13.3125 8.25 13 8.59375 13 9C13 9.4375 13.3125 9.75 13.75 9.75H17.25C17.6562 9.75 18 9.4375 18 9C18 8.59375 17.6562 8.25 17.25 8.25ZM7.75 8.25C7.3125 8.25 7 8.59375 7 9C7 9.4375 7.3125 9.75 7.75 9.75H10.25C10.6562 9.75 11 9.4375 11 9C11 8.59375 10.6562 8.25 10.25 8.25H7.75ZM4.5 7V2.03125C4.5 1.75 4.71875 1.53125 5 1.53125H10V4C10 4.5625 10.4375 5 11 5H13.4688V7H15V4.34375C15 3.8125 14.7812 3.3125 14.4062 2.9375L12.0625 0.59375C11.6875 0.21875 11.1875 0 10.6562 0H5C3.875 0 3 0.90625 3 2V7H4.5ZM13.5 14C13.5 14.2812 13.25 14.5 13 14.5H5C4.71875 14.5 4.5 14.2812 4.5 14L4.46875 11H3V14C3 15.125 3.90625 16 5 16H13C14.0938 16 15 15.125 15 14V11H13.5V14Z",
  fill: "#767B87"
});

const SvgRedline = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRedline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redline.e26cdeba.svg";
export { ForwardRef as ReactComponent };